// import axios from 'axios'
import baseURL from './baseUrl'

// 轮播图列表
export function homeData(query) {
  var url=baseURL?'/homeData':'/api/homeData'
  return axios({
    url,
    method: 'post',
    params: query
  })
}

// 轮播图列表
export function bannerList(query) {
  var url=baseURL?'/pc_banner':'/api/pc_banner'
  return axios({
    url,
    method: 'get',
    params: query
  })
}
// 城市列表
export function cityList(data) {
  var url=baseURL?'/pc_cityList':'/api/pc_cityList'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 首页分类
export function categoryList2() {
  var url=baseURL?'/pc_sycategory':'/api/pc_sycategory'
  return axios({
    url,
    method: 'post',
    params: {}
  })
}
// 特价商品
export function specialList(data) {
  var url=baseURL?'/pc_special':'/api/pc_special'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 热销商品
export function hotList(data) {
  var url=baseURL?'/pc_hot':'/api/pc_hot'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 首页商品列表
export function indexGoodsList(data) {
  var url=baseURL?'/pc_indexGoods':'/api/pc_indexGoods'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 友情链接
export function linkList(query) {
  var url=baseURL?'/pc_link':'/api/pc_link'
  return axios({
    url,
    method: 'get',
    params: query
  })
}

//测试
export function availableCateList(query) {
  var url=baseURL?'/availableCateList':'/api/availableCateList'
  return axios({
    url,
    method: 'post',
    params: query
  })
}

export function availableGoodsList(query) {
  var url=baseURL?'/availableGoodsList':'/api/availableGoodsList'
  return axios({
    url,
    method: 'post',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js